import { BaseComponent } from '@/mainComponent/items/BaseComponent';

class Prediction extends BaseComponent {
  isCollect: boolean = false;
  constructor() {
    super();
    this.init();
  }

  checkIsFullProgressWins(): void {
    if (
      (!this.store.promo.isAchievementFS && !this.store.promo.isAchievement && !this.store.promo.isAchievementBG) ||
      game.store.gameData.state !== 'gamble' ||
      this.store.promo.isFullAchievementProgress(this.achievement)
    )
      return;
    const progress: any = this.achievement.progress;
    const condition: string = Object.entries(progress)[0][0];
    switch (condition) {
      case 'wins':
        if (
          this.store.promo.isFullAchievementProgress(
            this.achievement,
            progress.wins.current + game.store.gameData.winAmount
          )
        )
          this.isCollect = true;
    }
  }

  override onShowWinEnter() {
    this.checkIsFullProgressWins();
    this.hideGamble();
  }

  override onShowWinAllLines() {
    this.sendCollect();
  }

  override onCheckExit() {
    this.checkIsFullProgressWins();
    this.hideGamble();
    this.sendCollect();
  }

  hideGamble(): void {
    if (!this.isCollect) return;
    this.store.gameData.gamble.isPlayed = true;
  }

  sendCollect() {
    if (!this.isCollect) return;
    game.component.network.sendCollect();
    this.isCollect = false;
  }

  get achievement(): any {
    return this.store.promo.achievement || this.store.promo.achievementBG || this.store.promo.achievementFS;
  }
}

export { Prediction };
